export default __webpack_public_path__ + "images/0d4387d22b9ef1ed35b4cd191bde86d2.png";